import {BaseEntity} from "../common/base-entity";

export class CirfUdf extends BaseEntity {
    fieldLabel: string;
    fieldValue: string;
    parentName: string;
}